import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SinglePropertyPageService } from 'src/services/SinglePropertyPageService';
import { SinglePropertyPageModel } from 'src/model/SinglePropertyPage3/SinglePropertyPageModel';
import { ContactService } from '../_services/contact.service';
import { ToasterService } from '../_services/toaster.service';
import { LoaderService } from '../_services/loader.service';
import { SeoService } from '../_services/seo.service';
import { JsonLdService } from '../_services/json-ld.service';

declare var $: any;

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.css'],
  providers: [SinglePropertyPageModel],
  standalone: false
})
export class PropertyDetailsComponent implements OnInit {

  constructor(
    private contactService: ContactService,
    private tostrService: ToasterService,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private httpService: SinglePropertyPageService,
    private seoService: SeoService,
    private jsonLdService: JsonLdService
  ) { }

  propertyModel: SinglePropertyPageModel;
  public FullName: string;
  public EmailAddress: string;
  public PhoneNumber: number;
  public Subject: string;
  public Message: string;
  public OwnerEmail: string;
  IsLoading = true;
  IsDiv = false;

  ngOnInit() {
    this.LoadDetailPage();
  }

  lightSlider() {
    $('#image-gallery').lightSlider({
      gallery: true,
      item: 1,
      thumbItem: 9,
      slideMargin: 0,
      speed: 500,
      auto: false,
      loop: true,
      onSliderLoad: function () {
        $('#image-gallery').removeClass('cS-hidden');
      }
    });
  }

  LoadDetailPage() {
    this.IsLoading = true;
    this.IsDiv = false;
    this.activatedRoute.paramMap.subscribe(params => {
      const propertyUrl = params.get('propertyUrl');
      if (propertyUrl !== null) {
        this.httpService.GetPropertyDetailsByUrl(propertyUrl).subscribe((data) => {
          this.propertyModel = data;
          this.OwnerEmail = data.EmailAddress;

          // SEO Optimization
          this.seoService.updateMetadata({
            title: `${data.Title} - ${data.Location}, ${data.City}`,
            description: `${data.Title} in ${data.Location}, ${data.City}. ${data.Description}`,
            image: data.Images[0],
            type: 'article'
          });

          // Structured Data (JSON-LD) for Rich Snippets
          this.jsonLdService.setData({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": data.Title,
            "description": data.Description,
            "image": data.Images[0],
            "brand": {
              "@type": "Brand",
              "name": "pakmatti.com"
            },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "PKR",
              "price": data.Price,
              "itemCondition": "https://schema.org/NewCondition",
              "availability": "https://schema.org/InStock"
            },
            "location": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": data.City,
                "addressRegion": data.Location
              }
            }
          });

          this.Subject = 'Property Query';
          this.Message = 'Hi,\rI am interested in your property "' + data.Title + '" advertised on www.pakmatti.com\rPlease let me know if it\'s still available.\rThanks.';

          setTimeout(() => {
            this.lightSlider();
          }, 100);
          this.IsLoading = false;
          this.IsDiv = true;
        });
      }
    });
  }

  ContactPropertyOwner(contactForm: any) {
    this.loaderService.showLoader();
    this.contactService.ContactPropertyOwner(contactForm.form.value).subscribe(response => {
      if (response.IsSuccess) {
        this.tostrService.Info(response.Message);
      } else {
        this.tostrService.Error(response.Message);
      }
      this.loaderService.hideLoader();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  showSlider(propertyModel: any) {
    const $lg = $('#dynamicLightGallery');
    $lg.unbind();
    const imageArray = $.makeArray(propertyModel?.Images).map(function (image, i) {
      return ({
        src: image,
        thumb: image,
        subHtml: '<div><h2 ><a href="#" style="color:#fff;">' + propertyModel?.Title + '</a></h2></div>'
      });
    });

    $lg.lightGallery({
      mode: 'lg-fade',
      cssEasing: 'ease',
      download: false,
      counter: false,
      autoplayControls: false,
      dynamic: true,
      zoom: false,
      fullScreen: false,
      googlePlus: false,
      pinterest: true,
      dynamicEl: imageArray
    });

    $lg.on('onCloseAfter.lg', function (event) {
      $lg.data('lightGallery').destroy(true);
    });
  }
}
